module.exports = __webpack_public_path__ + "static/media/streamline_the_hiring_process.e393c511.svg";